export default __webpack_public_path__ + "static/collage_image_3-4f2d4864d2f187800d5ace32f3d38e3d.jpg";